module.exports = __webpack_public_path__ + "img/bg-icon.78dfdeeb.svg";